import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const Profile = ({ user }) => {
    const [viewDropdown, setViewDropdown] = useState(false);
    const profileRef = useRef(null);
    const dropdownRef = useRef(null);
    const profilePicSrc = user.profilePicture
        ? `${process.env.REACT_APP_API_BASE_URL}/storage/profile/${user.profilePicture}`
        : null;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if ((dropdownRef.current && dropdownRef.current.contains(e.target)) || (profileRef.current && profileRef.current.contains(e.target))) return;
            setViewDropdown(false);
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = () => {
        setViewDropdown((prev) => !prev);
    };

    const logoutUser = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/logout`, { withCredentials: true });
            if (response.status === 200) {
                window.location.href = '/login.html';
            }
        } catch (error) {
            alert('Logout failed. Please try again.');
            console.error('Logout failed:', error);
        }
    }
    return (
        <div id='profileContainer' ref={profileRef}>
            <div id='profile-sub-container' onClick={toggleDropdown}>
                {user.profilePicture
                    ? <img src={profilePicSrc || ''} alt={`${user.firstName} ${user.lastName}`} id='profile-pic' />
                    : <span id='profile-pic' style={{ backgroundColor: '#ccc', display: 'inline-block' }}>{`${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`}</span>
                }
                {user.firstName && user.lastName
                    ? <span>{`${user.firstName} ${user.lastName}`}</span>
                    : <button onClick={() => window.location.href = '/login.html'}>Login</button>
                }
            </div>
            {viewDropdown && (
                <div id='profileDropdown' ref={dropdownRef}>
                    <button onClick={() => window.location.href = '/profile.html'}>Profile</button>
                    <button onClick={logoutUser}>Logout</button>
                </div>
            )}
        </div>
    )
};

export default Profile;